import { ISLAggregator, SLAggregator, AggName } from './slaggregator';
import { Column } from 'angular-slickgrid';
import { Type } from '@angular/core';
import { AggregatorFactory } from './aggregator-factory';
import { EmptyObject, AggregatorTotalsHandler, AttributeInfo, AnyHandler } from 'src/app/types/@types/sl-v-types';
import { Dict } from 'src/app/types/decorable';


export type AggList = {
	[key in AggName]?: ISLAggregator;
}
export type AggColumnInfo = {
	[aggName in AggName]?: Array<Column<any>>;
}
export type AggColumnIds = {
	[aggName in AggName]?: Array<string>;
}
export type AggInfo = {
	aggName: string;
	aggLabel: string;
	groupable: boolean;
}

export class AggregatorSet extends SLAggregator {

	protected _set: AggList = {};
	protected aggCount: 0;
	protected groupableCount: 0;
	protected asGroup: boolean;

	_completeHandler: AnyHandler = null;
	public get length() {
		return this.__count;
	}
	// tslint:disable-next-line: variable-name
	__count = 0;
	constructor(asGroup = false) {
		super();
		this.asGroup = asGroup;
	};
	init() {
		super.init();
		this.aggCount = 0;
		this.__count = 0;
		this.groupableCount = 0;
		if (!this._set) { return; }
		for (const aggName in this._set) {
			if (this._set.hasOwnProperty(aggName)) {
				const agg = this._set[aggName];
				if (agg === null || (!!this.asGroup && !agg.groupable)) { continue; }
				this.aggCount += 1;
				this.groupableCount += (agg.groupable === true ? 1 : 0);
				agg.init();
			}
		}
		return;
	}
	accumulate(item: any) {
		if (!this._set) { return; }
		for (const aggName in this._set) {
			if (this._set.hasOwnProperty(aggName)) {
				const agg = this._set[aggName];
				if (!agg) { continue; }
				if ((agg.groupable === false) && (this.asGroup === true)) { return; }
				agg.accumulate(item);
			}
		}

	}
	SetColumns(_cols: Array<Column<any>>) {
		return;
	}
	AddColumn(_column: Column<any>) {
		return;
	}
	RemoveColumn(_column: Column<any>): number {
		return;
	}
	HasColumn(column: Column<any>): boolean {
		return (this._columns.indexOf(column) > -1);
	}

	AddAggColumn(aggName: AggName, column: Column<any>) {
		if (!this._set) {
			this._set = {};
		}
		if (!this._set[aggName]) {
			const aggClass: Type<ISLAggregator> = AggregatorFactory.GetAggregatorByName(aggName);
			this._set[aggName] = new aggClass();
			this.aggCount += 1;
		}
		this._set[aggName].AddColumn(column);
	}
	RemoveAggColumn(aggName: AggName, column: Column<any>) {
		if (!this._set) {
			this._set = {};
		}

		if (!this._set[aggName]) { return; }

		const colsLeft = this._set[aggName].RemoveColumn(column);
		if (colsLeft === 0) {
			delete this._set[aggName];
			this.aggCount -= 1;
		}
	}
	HasAgg(aggName: AggName) {
		if (!this._set[aggName]) {
			return false;
		}
		return !!this._set[aggName];
	}
	HasAggColumn(aggName, column: Column<any>) {
		if (!this._set[aggName]) {
			return false;
		}
		return this._set[aggName].HasColumn(column);
	}
	ColumnHasAggs(column: Column<any>): boolean {
		let matchCount = 0;
		for (const aggName in this._set) {
			if (this._set.hasOwnProperty(aggName)) {
				const agg = this._set[aggName];
				matchCount += (agg.HasColumn(column) === true) ? 1 : 0;
			}
		}
		return matchCount > 0;
	}
	ToggleAggColumn(aggName, column, isOn?: boolean) {
		const hasAggColumn = this.HasAggColumn(aggName, column);
		if (isOn === true) {
			if (hasAggColumn === false) {
				this.AddAggColumn(aggName, column);
			}
			return;
		}
		if (isOn === false) {
			if (hasAggColumn === true) {
				this.RemoveAggColumn(aggName, column);

			}
			return;
		}
		// isOn not specified, toggle
		if (hasAggColumn === true) {
			this.RemoveAggColumn(aggName, column);
		} else {
			this.AddAggColumn(aggName, column);
		}
	}
	GetColumns() {
		return this._columns;
	}
	GetAggColumnInfo(): AggColumnInfo | EmptyObject {
		if (!this._set) {
			return {};
		}
		const info = {};
		for (const aggName in this._set) {
			if (this._set.hasOwnProperty(aggName)) {
				info[aggName] = this._set[aggName].GetColumns();
			}
		}
		return info;
	}
	GetAggColumnIds(): AggColumnIds | EmptyObject {
		if (!this._set) {
			return {};
		}
		const info = {};
		for (const aggName in this._set) {
			if (this._set.hasOwnProperty(aggName)) {
				info[aggName] = this.GetColumnIds(this._set[aggName].GetColumns());
			}
		}
		return info;
	}
	GetColumnIds(columns: Array<Column<any>>): Array<string> {
		const ids = [];
		for (const col of columns) {
			ids.push('' + col.id);
		}
		return ids;
	}
	GetColumn(columns: Array<Column<any>>, columnId: string): Column<any> | false {
		for (const column of columns) {
			if ('' + column.id === columnId) {
				return column;
			}
		}
		return false;
	}
	FromAggColumnIds(gridColumns: Array<Column<any>>, aggColumnIds: AggColumnIds) {
		this._set = {};
		this.init();
		this._columns = [];
		for (const aggName in aggColumnIds) {
			if (aggColumnIds.hasOwnProperty(aggName)) {
				const name: AggName = aggName as AggName;
				const colIds: Array<string> = aggColumnIds[name];
				const cols = [];
				for (const colId of colIds) {
					const column = this.GetColumn(gridColumns, colId);
					if (column !== false) {
						cols.push(column);
					}
				}
				const aggregator: Type<ISLAggregator> = AggregatorFactory.GetAggregatorByName(name as AggName);
				this._set[aggName] = new aggregator();
				this._set[aggName].SetColumns(cols);
			}
		}
	}
	FromAggColumnInfo(aggColumnInfo: AggColumnInfo) {
		this._set = {};
		this.init();
		this._columns = [];
		for (const aggName in aggColumnInfo) {
			if (aggColumnInfo.hasOwnProperty(aggName)) {
				const name: AggName = aggName as AggName;
				const cols: Array<Column<any>> = aggColumnInfo[name];
				const aggregator: Type<ISLAggregator> = AggregatorFactory.GetAggregatorByName(name as AggName);
				this._set[aggName] = new aggregator();
				this._set[aggName].SetColumns(cols);
			}
		}
	}
	storeResult(totals: any, completeHandler?: AnyHandler) {
		if (!this._set) { return; }
		this._completeHandler = completeHandler;
		this._value = {};
		for (const aggName in this._set) {
			if (this._set.hasOwnProperty(aggName)) {
				const agg = this._set[aggName];
				if (agg === null) { continue; }
				if ((agg.groupable === false) && (this.asGroup === true)) { continue; }
				agg.SetTotals(totals, (t: any) => {
					this.Complete(aggName as AggName, t);
				});
			}
		}
		return;

	}
	Complete(aggName: AggName, totals: any) {
		if (!this.__count) {
			this.__count = 0;
		}
		this.__count += 1;
		this._value = totals;
		const totalCount = (this.asGroup === true) ? this.groupableCount : this.aggCount;
		if (this.__count === totalCount) {
			if (this._completeHandler) {
				this._completeHandler(this._value);
				delete this._completeHandler;
			}
		}
	}

	InitTotals(totals: any) {
		if (!totals[this._name]) {
			totals[this._name] = {};
		}
	}

	EndAggregation(totals: any, completeHandler?: AggregatorTotalsHandler) {
		this._completed += 1;
		if (this._completed === this.aggCount) {
			if (!!completeHandler) {
				completeHandler(totals, this._value, this.requiresInvalidation);
			}
		}
	}
	GetLabel(): string {
		return this._label;
	}
	GetName(): string {
		return this._name;
	}
	GetAggregatorInfo(): Array<AggInfo> {
		const info: Array<AggInfo> = [];

		const aggNames = Object.keys(this._set);
		aggNames.sort();
		for (const aggName of aggNames) {
			if (this._set.hasOwnProperty(aggName)) {
				info.push({ aggName: (aggName), aggLabel: this._set[aggName].GetLabel(), groupable: this._set[aggName].groupable });
			}
		}

		return info;
	}
	GetGroupableCount(): number {
		return this.groupableCount;
	}
	GetValue(): Dict {
		const value = {};
		for (const aggName in this._set) {
			if (this._set.hasOwnProperty(aggName)) {
				value[aggName] = this._set[aggName].GetTotal();
			}
		}
		return value;

	}
	Reset() {
		this._set = {};
		this.init();
	}

}